:host {
  display: block;
  width: 100%;
  height: 100%;
}

.workflow-canvas {
  border-width: 1px;
  border-radius: 3px;
  border-style: solid;
  height: 100%;
}

.task-overlay {
  position: relative;
  opacity: 1;
  border-radius: 10px;
  display: flex;
  flex-direction: row-reverse;
}

.task-heatmap {
  opacity: 0.5;
  border-radius: 10px;
}

.task-count {
  position: absolute;
  background-color: #2F4F4F;
  margin-top: -21px;
  padding-left: 5px;
  padding-right: 5px;
  opacity: 1;
  border-radius: 10px;
  border-style: solid;
  border-width: 1px;
  font-size: 0.7rem;
  color: #FFFFFF;
}
